/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  Component,
  OnInit
}                                from '@angular/core';

import { User       } from '@/models/user';

import { Logger                } from '@/util/logger';
import {first} from "rxjs/operators";
import {IUserRow} from "@/screens/administration/i.user.row";

import {UserService} from "@/services/user.service";
import {AuthenticationService} from "@/services/authentication.service";
import {empty} from "@/util/util";

@Component({
  standalone: false,
  templateUrl: 'profile.component.html'
})

/**
 *
 * @class ProfileComponent
 *
 * @brief the user's profile page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class ProfileComponent implements OnInit {

  /** the logged in user */
  public user: User = null;

  /** the user's profile pic / avatar, if theere is one */
  public profilePic: string = '<img class="profile-icon" src="assets/images/profile-512.png">';

  /** standard constructor */
  constructor(
    private auth: AuthenticationService,
    private users: UserService
  ) {

  }

  /** on page setup */
  ngOnInit() {

    Logger.debug('[ProfileComponent] init...');

    let pc: ProfileComponent = this;

    this.user = this.auth.userOfSession;

    /* set the profile pic if we can */

    this.profilePic = `<img class="profile-icon" src="/assets/images/profile-512.png">`;

    if ((typeof pc.user.options != 'undefined') && (pc.user.options != null)) {

      if ((typeof pc.user.options.picture != 'undefined') &&
          (pc.user.options.picture != null) &&
          !empty(pc.user.options.picture)) {

        pc.profilePic = `<img class="profile-icon" src="${pc.user.options.picture}">`;
      }

    }

  }

}

